import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ className = '' }) => (
  <img
    className={className}
    src="/svgs/racing_post_plus_small.svg"
    alt="barrier-rp-logo-plus"
  />
);

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
